<template>
    <div class="mysection">
        <div class="mywxlist">
            <h3>
                我的债权转让(总金额<span class="color_red">{{this.wxAssignmentDebtContractAmount}}</span>元)
                <div class="list_title_right">共<span class="color_red">{{this.wxMyAssignmentDebtCount}}</span>条</div>
            </h3>
            <ul>
                <li v-for="item in wxMyAssignmentDebtArray">
                    <h4>{{item.projectName}}：{{item.projectCode}}</h4>
                    <el-row class="idata">
                        <el-col :span="8"><span class="color_red">{{item.contractAmount}}元</span>成交金额</el-col>
                        <el-col :span="8"><span>{{item.wxYieldRate}}%</span>利率</el-col>
                        <el-col :span="8"><span>{{item.deadline}}天</span>期限</el-col>
                    </el-row>
                    <el-row class="statics">
                        <!--<el-col :span="8"><span>担保公司名称</span></el-col>-->
                        <el-col :span="24">
                            <el-button size="small" type="default" plain v-on:click="toWxAssignmentDebtDetail(item.id)">
                                查看
                                <i class="el-icon-arrow-right el-icon--right"></i>
                            </el-button>
                        </el-col>
                    </el-row>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
  import {reqWxMyAssignmentDebtPage} from '../../api/weixin-api'

  export default {
        data(){
            return{
              wxMyAssignmentDebtCount:0,
              wxAssignmentDebtContractAmount:0,
              wxMyAssignmentDebtArray:[],
            }
        },
        methods:{

          isWechatBrowser: function () {
            let that=this;
            let ua = navigator.userAgent.toLowerCase();
            let isWeixin = ua.indexOf('micromessenger') !== -1;
            if (!isWeixin) {
              that.$router.push({name: 'wxError'});
            }
          },
          show_wxMyAssignmentDebt_page(userId){
            reqWxMyAssignmentDebtPage({userId:userId}).then((res)=>{
              if(res.data.code===1){
                this.wxMyAssignmentDebtCount=res.data.data.pAssignmentDebt.wxTotals;
                this.wxAssignmentDebtContractAmount=res.data.data.pAssignmentDebt.wxContractAmount;
                this.wxMyAssignmentDebtArray=res.data.data.list;
              }else {
                this.wxMyAssignmentDebtCount=0;
                this.wxAssignmentDebtContractAmount=0;
                this.wxMyAssignmentDebtArray=[];
              }
            })
          },
          toWxAssignmentDebtDetail(id){
            this.$router.push({path:'wxAssignmentDebtDetail',query:{id:id,WxAssignmentDebtDetail:1,userId:this.$route.query.userId}})
          },
          backWeiXin:function() {
            pushHistory();
            function bodyScroll(){
              window.location.href='/wxMyHomePage';

            }
            window.addEventListener("popstate",bodyScroll, false);
            function pushHistory() {
              var state = {
                title: "title",
                url: ""
              };
              window.history.pushState(state, state.title, state.url);
            }
          }
        },
        mounted(){
            this.$store.dispatch('hideHF');
            this.isWechatBrowser();

            var userId=this.$route.query.userId;
          if(userId){
            this.show_wxMyAssignmentDebt_page(userId);
          }
          this.backWeiXin()
        }
    }
</script>
<style slot-scope="scope">
    @import '../../assets/css/wxstyle.css';
</style>



// WEBPACK FOOTER //
// src/components/weChat/WxMyAssignmentDebt.vue